import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './hooks/useAuth';
import { AccessRestrictionProvider } from '@/context/AccessRestrictionContext';
import App from './App';
import { PUBLIC_JOBS_SSR_ATTR } from '@/careers/constants';
document.querySelectorAll(`[${PUBLIC_JOBS_SSR_ATTR}]`).forEach((el) => el.remove());
import './index.css';
import { LoadingProvider } from '@/provider/LoadingProvider';
import { RouteLoadingGateClassic } from '@/provider/RouteLoadingGate';
import { ThemeProvider } from '@/provider/ThemeProvider';
import '@/lib/i18n';
import { queryClient } from '@/lib/queryClient';
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Suspense
      fallback={
        <div className='min-h-screen flex items-center justify-center bg-background text-foreground'>Loading...</div>
      }
    >
      <ThemeProvider>
        <LoadingProvider>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <AuthProvider>
                <AccessRestrictionProvider>
                  <RouteLoadingGateClassic minVisibleMs={300} />
                  <App />
                </AccessRestrictionProvider>
                <Toaster
                  position='top-right'
                  toastOptions={{
                    duration: 4000,
                    className: 'bg-card text-card-foreground border border-border shadow-lg backdrop-blur-none',
                    style: {
                      background: 'hsl(var(--card))',
                      color: 'hsl(var(--card-foreground))',
                      border: '1px solid hsl(var(--border))',
                      borderRadius: 'var(--radius)',
                      boxShadow: 'var(--shadow-lg)',
                      opacity: 1,
                      backdropFilter: 'none',
                    },
                    success: {
                      className: '!bg-card text-card-foreground border-[hsl(var(--success))]',
                      style: {
                        background: 'hsl(var(--card))',
                        color: 'hsl(var(--card-foreground))',
                        border: '1px solid hsl(var(--success))',
                        borderRadius: 'var(--radius)',
                        boxShadow: 'var(--shadow-lg)',
                        opacity: 1,
                      },
                    },
                    error: {
                      className: '!bg-card text-card-foreground border-[hsl(var(--destructive))]',
                      style: {
                        background: 'hsl(var(--card))',
                        color: 'hsl(var(--card-foreground))',
                        border: '1px solid hsl(var(--destructive))',
                        borderRadius: 'var(--radius)',
                        boxShadow: 'var(--shadow-lg)',
                        opacity: 1,
                      },
                    },
                    loading: {
                      className: '!bg-card text-card-foreground border-[hsl(var(--info))]',
                      style: {
                        background: 'hsl(var(--card))',
                        color: 'hsl(var(--card-foreground))',
                        border: '1px solid hsl(var(--info))',
                        borderRadius: 'var(--radius)',
                        boxShadow: 'var(--shadow-lg)',
                        opacity: 1,
                      },
                    },
                  }}
                />
              </AuthProvider>
            </BrowserRouter>
          </QueryClientProvider>
        </LoadingProvider>
      </ThemeProvider>
    </Suspense>
  </React.StrictMode>
);
